<ng-container *transloco="let t; read: 'calculator_result.download_pdf'">
  <psc-button
    [width]="325"
    [label]="t('button_title')"
    (buttonClicked)="downloadPdfClicked()">
  </psc-button>
  <psc-dialog
    *ngIf="showPdfDialog"
    [title]="t('dialog_title')"
    (closeClicked)="showPdfDialog = false">
    <div class="flex flex-col items-center">
      <form [formGroup]="formGroup" class="flex flex-col gap-4 self-start w-full">
        <psc-input
          [readonly]="!!this.powerPlant"
          formControlName="project_title"
          [label]="t('project_title')"></psc-input>

        <psc-input
          [readonly]="!!this.powerPlant"
          formControlName="investor"
          [label]="t('investor')"></psc-input>

        <psc-input
          [readonly]="!!this.powerPlant"
          formControlName="address"
          [label]="t('address')"></psc-input>

        <psc-file-input
          *ngIf="!this.powerPlant"
          formControlName="image"
          [label]="t('image')"></psc-file-input>

        <psc-textarea
          formControlName="conclusion"
          [label]="t('conclusion')"></psc-textarea>

        <psc-checkbox
          class="mb-2"
          formControlName="expanded">{{t('expanded')}}</psc-checkbox>

        <div class="flex gap-3">
          <psc-button
            [label]="t('generate')"
            [disabled]="!formGroup.valid"
            type="primary-blue-2"
            (buttonClicked)="submitPDFData()"></psc-button>

          <psc-button
            [label]="t('cancel')"
            type="secondary-magenta"
            (buttonClicked)="showPdfDialog = false"></psc-button>
        </div>
      </form>
    </div>
  </psc-dialog>
</ng-container>
